<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#ee0909"
  type="ball-atom"
  [fullScreen]="true"
>
  <p style="color: white">cargando ....</p>
</ngx-spinner>

<div class="container">
  <div class="row"></div>

  <div class="title-container">
    <!-- TODO esta es la vista -->
    <b class="title">Listado de Organismos Certificadores</b>
  </div>
  <app-organismos-table-principal></app-organismos-table-principal>
</div>
